import { getLoginURL, getLogoutURL } from './urls';

export function login(projectId?: string) {
  window.location.assign(
    getLoginURL({ backTo: window.location.href, projectId }),
  );
}

export function logout(projectId?: string) {
  window.location.assign(
    getLogoutURL({ backTo: window.location.origin, projectId }),
  );
}
